import { useLocation } from 'wouter'

export default function NotFound() {
  const [, setLocation] = useLocation()

  return (
    <section className="h-full">
      <div className="container flex items-center h-full px-6 py-12 mx-auto">
        <div>
          <p className="text-sm font-medium text-accent dark:text-accent">
            404 error
          </p>
          <h1 className="mt-3 text-2xl font-semibold text-gray-800 dark:text-white md:text-3xl">
            No podemos encontrar esa página.
          </h1>
          <p className="mt-4 text-gray-500 dark:text-gray-400">
            Lo sentimos, la página que buscas no existe o ha sido movida.
          </p>

          <div className="flex items-center mt-6 gap-x-3">
            <button
              type="button"
              onClick={() => setLocation('/')}
              className="px-5 py-2 text-sm text-white transition-colors duration-200 border rounded-sm w-fit bg-accent border-accent dark:hover:bg-gray-800 enabled:hover:bg-white enabled:hover:text-accent dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:enabled:hover:bg-gray-800 disabled:opacity-30 focus:ring-opacity-20 focus:outline-none focus:ring focus:ring-accent focus:border-accent dark:focus:border-accent"
            >
              Ir a la página de inicio
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
